
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { ProductLimitsTable } from "@/components/admin/product-limits/ProductLimitsTable";
import { Database } from "lucide-react";

const ProductLimits = () => {
  return (
    <DashboardLayout userType="admin">
      <div className="container mx-auto p-6">
        <div className="flex items-center gap-2 mb-6">
          <Database className="h-6 w-6 text-primary" />
          <h1 className="text-2xl font-bold">Limites de produits personnalisées</h1>
        </div>
        <ProductLimitsTable />
      </div>
    </DashboardLayout>
  );
};

export default ProductLimits;
